import React, { Component } from "react";
import { ToastContainer } from 'react-toastify';
import { Grid, Box, Tabs, Tab, Tooltip } from "@mui/material";
import { NavLink, Routes, Route } from "react-router-dom";
import History from "../../utils/history";
import "../../admin.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faCog,
  faBackward,
} from "@fortawesome/free-solid-svg-icons";
import AdminDashboard from "./adminDashboard";
import AdminDashboardV2 from "./AdminDashboardV2";
import AdminSettings from "./adminSettings";
import AdminUsers from "./adminUsers";
import AdminUsersV2 from "./AdminUsersV2";

class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: window.location.pathname,
    };
  }

  componentDidMount() {
    this.unlisten = History.listen(({ location }) => {
      this.setState({ value: location.pathname });
    });
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  render() {
    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Grid container sx={{ minHeight: "100vh", width: "100%", m: 0 }}>
          <Box
            sx={{
              minHeight: "100vh",
              backgroundColor: "#EEEEEE",
              position: "fixed",
              left: 0,
              top: 0,
              width: "60px",
              zIndex: 100,
              display: "flex",
              flexDirection: "column",
              borderRight: 1,
              borderColor: "divider",
            }}
          >
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={this.state.value}
              aria-label="Admin navigation"
              sx={{
                '& .MuiTabs-indicator': {
                  left: 0,
                  width: '4px',
                },
              }}
            >
              <Tab
                icon={<Tooltip title="Dashboard" placement="right"><FontAwesomeIcon icon={faHome} /></Tooltip>}
                component={NavLink}
                to="/dashboard"
                value="/dashboard"
                sx={{ minWidth: "60px", py: 2 }}
              />
              <Tab
                icon={<Tooltip title="Users" placement="right"><FontAwesomeIcon icon={faUser} /></Tooltip>}
                component={NavLink}
                to="/users"
                value="/users"
                sx={{ minWidth: "60px", py: 2 }}
              />
              <Tab
                icon={<Tooltip title="Settings" placement="right"><FontAwesomeIcon icon={faCog} /></Tooltip>}
                component={NavLink}
                to="/settings"
                value="/settings"
                sx={{ minWidth: "60px", py: 2 }}
              />
              <Tab
                icon={<Tooltip title="Go back" placement="right"><FontAwesomeIcon icon={faBackward} /></Tooltip>}
                onClick={() => {
                  localStorage.setItem("adminMode", "false");
                  History.push("/");
                  window.location.reload(false);
                }}
                sx={{ minWidth: "60px", color: "text.secondary", py: 2 }}
              />
              <Tab
                label="Sign Out"
                onClick={() => this.props.logout()}
                sx={{
                  minWidth: "60px",
                  color: "error.main",
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                }}
              />
            </Tabs>
          </Box>
          <Grid item xs={12} sx={{ pl: "60px", maxHeight: "100vh", overflowY: "auto", width: "calc(100% - 60px)" }}>
            <Routes>
              <Route path="/" element={<AdminDashboardV2 token={this.props.token} AWS={this.props.AWS} />} />
              <Route path="/dashboard" element={<AdminDashboardV2 token={this.props.token} AWS={this.props.AWS} />} />
              <Route path="/dashboard-v1" element={<AdminDashboard token={this.props.token} AWS={this.props.AWS} />} />
              <Route path="/settings" element={<AdminSettings token={this.props.token} />} />
              <Route path="/users" element={<AdminUsersV2 token={this.props.token} />} />
              <Route path="/users-v1" element={<AdminUsers token={this.props.token} AWS={this.props.AWS} />} />
            </Routes>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default AdminLayout;
